import privacyMd from "../../../../../docs/legal/aviso_privacidad.md?raw";
import simplifiedMd from "../../../../../docs/legal/aviso_simplificado.md?raw";
import termsMd from "../../../../../docs/legal/terminos.md?raw";

/** Candado: un texto legal con algún marcador {{ }} o [COMPLETAR: ] sin llenar no se publica. */
export const isPublishable = (md: string) =>
  !md.includes("{{") && !md.includes("[COMPLETAR:");

export interface LegalDoc {
  path: string;
  label: string;
  md: string;
}

export const PRIVACY_DOC: LegalDoc = {
  path: "/aviso-privacidad",
  label: "Aviso de privacidad",
  md: privacyMd,
};
export const TERMS_DOC: LegalDoc = {
  path: "/terminos",
  label: "Términos de uso",
  md: termsMd,
};

/** Texto plano del pie de correo: el bloque citado del aviso simplificado, o null si aún tiene marcadores. */
export const simplifiedNotice = (md: string): string | null => {
  if (!isPublishable(md)) return null;
  const quote = md
    .split("\n")
    .filter((line) => line.startsWith(">"))
    .map((line) => line.replace(/^>\s?/, ""))
    .join("\n")
    .replace(/\*\*/g, "")
    .trim();
  return quote || null;
};

export const SIMPLIFIED_NOTICE = simplifiedNotice(simplifiedMd);
